"use strict";

module.exports = {
  NEW: 'NEW',
  ACCOUNTED_FOR: 'ACCOUNTED_FOR',
  LOCATION_MATCH: 'LOCATION_MATCH',
  LOCATION_MISMATCH: 'LOCATION_MISMATCH',
  UNSCANNED: 'UNSCANNED'
};